import { render } from "./SupportDeskPage.vue?vue&type=template&id=fcdb26a6&ts=true"
import script from "./SupportDeskPage.vue?vue&type=script&lang=ts"
export * from "./SupportDeskPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__